import styles from './delete-course-dialog.module.scss';
import { makeCourseRequest, useCourseGetRequestHook } from '../../../requestUtils';
import { useContext, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, LoadingButton, SnackBarContext, Typography } from '@frontend-workspace/react-shared-lib';
import { ICourse } from '../../../_models/course';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface DeleteCourseDialogProps {
  onClose: () => void,
  open: boolean,
  refreshData: () => void,
  courseId: string
}

export function DeleteCourseDialog(props: DeleteCourseDialogProps) {
  const { data: course }: { data: ICourse } = useCourseGetRequestHook(`course/get/${props.courseId}`, undefined);

  const { t } = useTranslation();
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const [loading, setLoading] = useState<boolean>(false);

  const handleDeleteCourse = () => {
    setLoading(true);
    // Todo:: Should be fixed on BE
    makeCourseRequest(`course/delete/${props.courseId}`, 'DELETE').then(result => {
      if (result.error) {
        setSnackbarMessage({ content: result.errorMessage, type: "error" });
      } else {
        setSnackbarMessage({ content: "Slettet kurset fra listen.", type: "success" });
      }
      setLoading(false);
      props.refreshData();
      props.onClose();
    }).catch((error) => {
      // Uses app.tsx => error.response.data => SnackbarMessage
      // setSnackbarMessage({ content: error.errorMessage, type: "error" });
    });
  };

  return (
    <Dialog
      open={props.open}
      maxWidth="sm"
      fullWidth>
      <DialogTitle className='mb-4'>
        {t("deleteCourse.areYouSureYouWantToDeleteCourse")}
      </DialogTitle>
      <DialogContent>
        <Typography
          component="div"
          variant='subtitle3'
          className='mb-3'>
          {course?.courseName}
        </Typography>
      </DialogContent>
      <DialogActions>
        <LoadingButton
          variant="contained"
          size='large'
          color='error'
          onClick={handleDeleteCourse}
          disabled={loading}
          loading={loading}
          className='minButtonWidth'>
          {loading ? '' : t("standard.delete")}
        </LoadingButton>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default DeleteCourseDialog;
